import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Banner from '../Banner';

const UndeliverableAddressBanner = ({ account, history }) => {
  const [isBannerVisible, setIsBannerVisible] = useState(
    account?.Address?.IsUndeliverable === true
  );

  const onEditContactInfoClick = () => {
    setIsBannerVisible(false); // Close the banner
    history.push(`/accounts/${account.AccountNumber}/edit`);
  };

  const onLinkClick = () => {
    setIsBannerVisible(false); // Close the banner
  };

  if (!isBannerVisible) return null;

  return (
    <>
      <div style={{ marginTop: isBannerVisible ? '80px' : '0' }}>
        {/* This div wraps the rest of the page content */}
      </div>
      <Banner
        isVisible={isBannerVisible}
        actions={[
          {
            label: 'Edit Contact Info',
            onClick: onEditContactInfoClick,
            variant: 'contained',
            color: 'primary',
          },
        ]}
        sx={{
          backgroundColor: '#fff7e6', // Softer light yellow background
          color: '#b45309', // Dark orange text
          padding: '2rem', // Increased padding for better spacing
          margin: '0',
          fontSize: '1.25rem', // Larger font size
          border: '1px solid #facc15', // Yellow border
          borderRadius: '12px', // Rounded corners
          boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)', // Subtle shadow
          display: 'flex',
          flexDirection: 'column', // Stack content vertically
          justifyContent: 'center', // Center content vertically
          alignItems: 'center', // Center content horizontally
          textAlign: 'center', // Center-align text
          gap: '1rem', // Add spacing between elements
          position: 'fixed', // Fix the banner at the top
          top: '0', // Align it to the top
          left: '0',
          right: '0',
          zIndex: 1000, // Ensure it appears above other elements
        }}
      >
        <p style={{ margin: 0, fontWeight: '600', lineHeight: '1.75', fontSize: '1.5rem', color: '#92400e' }}>
          Your address was marked undeliverable by the USPS. Please update your address{' '}
          <Link
            to={`/accounts/${account.AccountNumber}/edit`}
            style={{
              textDecoration: 'underline',
              color: '#2563eb', // Blue link color
              fontWeight: 'bold',
              transition: 'color 0.3s ease',
            }}
            onClick={onLinkClick} // Close the banner when the link is clicked
            onMouseEnter={(e) => (e.target.style.color = '#1e40af')} // Darker blue on hover
            onMouseLeave={(e) => (e.target.style.color = '#2563eb')} // Reset color on mouse leave
          >
            here
          </Link>{' '}
          or by clicking Edit Contact Info.
        </p>
      </Banner>
    </>
  );
};

export default withRouter(UndeliverableAddressBanner);
